import React from "react";
import { Lock } from "react-feather";
import { STAFF_AVAILABILITY_LOCKED_MESSAGE } from "../../utils/authHelper";

const StaffAvailabilityLockOverlay = ({ locked, children }) => {
  if (!locked) {
    return children;
  }

  return (
    <div className="staff-availability-lock-wrap">
      <div className="staff-availability-lock-content" aria-hidden="true">
        {children}
      </div>
      <div className="staff-availability-lock-overlay">
        <Lock size={36} />
        <p>{STAFF_AVAILABILITY_LOCKED_MESSAGE}</p>
      </div>
    </div>
  );
};

export default StaffAvailabilityLockOverlay;
